<template>
  <div>
    <b-row>
      <b-col
        md="8"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <p class="h5 mt-50 mr-75 ml-50">
          일별/누적
        </p>
        <b-form-radio-group
          v-model="query.isPrefixSum"
          @change="changePrefixSum"
        >
          <b-form-radio :value="false">
            일별 (기간:최대30일)
          </b-form-radio>
          <b-form-radio :value="true">
            누적 (기간:최대1년)
          </b-form-radio>
        </b-form-radio-group>
        <b-form-datepicker
          v-model="query.startDate"
          class="el-def"
          placeholder="조회기간(Fr)"
          style="width: 240px"
        />
        <label class="ml-50 mr-50">~</label>
        <b-form-datepicker
          v-model="query.endDate"
          class="el-def"
          placeholder="조회기간(To)"
          style="width: 240px"
        />
      </b-col>
      <b-col
        md="4"
        class="d-flex align-items-center justify-content-end"
      >
        <b-button
          variant="primary"
          class="btn-search"
          @click.prevent="fetchData()"
        >
          조회
        </b-button>
        <b-button
          variant="outline-dark"
          class="btn-search ml-1"
          @click.prevent="excelDownload()"
        >
          <feather-icon
            icon="DownloadIcon"
            class="mr-50"
          />
          <span>엑셀 다운로드</span>
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col
        cols="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-table-simple
          bordered
          responsive
          sticky-header
          style="max-height: 65vh;"
        >
          <colgroup>
            <col style="width: 140px">
            <!-- 메디컬트렌드 -->
            <col style="width: 100px">
            <col style="width: 100px">
            <!-- Weekly Choice -->
            <col style="width: 100px">
            <col style="width: 100px">
            <!-- 약품정보 -->
            <col style="width: 100px">
            <col style="width: 100px">
            <!-- 공지사항 -->
            <col style="width: 100px">
            <col style="width: 100px">
            <!-- 이벤트 -->
            <col style="width: 100px">
            <col style="width: 100px">
          </colgroup>
          <b-thead head-variant="light">
            <b-tr>
              <b-th rowspan="2">
                구분
              </b-th>
              <b-th colspan="2">
                메디컬트렌드
              </b-th>
              <b-th colspan="2">
                Weekly Choice
              </b-th>
              <b-th colspan="2">
                약품정보
              </b-th>
              <b-th colspan="2">
                공지사항
              </b-th>
              <b-th colspan="2">
                이벤트
              </b-th>
            </b-tr>
            <b-tr>
              <b-th style="top: 38.55px;">
                댓글 수
              </b-th>
              <b-th style="top: 38.55px;">
                작성자 수
              </b-th>
              <b-th style="top: 38.55px;">
                댓글 수
              </b-th>
              <b-th style="top: 38.55px;">
                작성자 수
              </b-th>
              <b-th style="top: 38.55px;">
                댓글 수
              </b-th>
              <b-th style="top: 38.55px;">
                작성자 수
              </b-th>
              <b-th style="top: 38.55px;">
                댓글 수
              </b-th>
              <b-th style="top: 38.55px;">
                작성자 수
              </b-th>
              <b-th style="top: 38.55px;">
                댓글 수
              </b-th>
              <b-th style="top: 38.55px;">
                작성자 수
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-if="data.length > 0">
            <b-tr
              v-for="(m, idx) in data"
              :key="`tr-${idx}`"
              :class="{ 'table-active': idx === data.length - 1 }"
            >
              <b-td>{{ (data.length === 1 && m.isPrefixSum) ? '누적 수' : (m.isPrefixSum ? "합계" : m.date) }}</b-td>
              <b-td>{{ m.medicalTrendTotalCount | $numberFormatter }}</b-td>
              <b-td>{{ m.medicalTrendGroupCount | $numberFormatter }}</b-td>
              <b-td>{{ m.weeklyChoiceTotalCount | $numberFormatter }}</b-td>
              <b-td>{{ m.weeklyChoiceGroupCount | $numberFormatter }}</b-td>
              <b-td>{{ m.drugInfoTotalCount | $numberFormatter }}</b-td>
              <b-td>{{ m.drugInfoGroupCount | $numberFormatter }}</b-td>
              <b-td>{{ m.noticeTotalCount | $numberFormatter }}</b-td>
              <b-td>{{ m.noticeGroupCount | $numberFormatter }}</b-td>
              <b-td>{{ m.eventTotalCount | $numberFormatter }}</b-td>
              <b-td>{{ m.eventGroupCount | $numberFormatter }}</b-td>
            </b-tr>
          </b-tbody>

          <b-tbody v-else>
            <b-tr>
              <b-td colspan="11">
                <div
                  role="alert"
                  aria-live="polite"
                >
                  <div class="text-center my-2">
                    일치하는 데이터가 없습니다.
                  </div>
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import axios from '@axios'
import {
  BTableSimple, BThead, BTbody, BTr, BTh, BTd,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"

export default {
  components: {
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  setup() {
    const data = ref([])

    onMounted(() => {
      fetchData()
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon

      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const changePrefixSum = () => {
      if (query.value.isPrefixSum) {
        query.value.startDate = dayjs().add(-1, 'month').format('YYYY-MM-DD')
      } else {
        query.value.startDate = dayjs().add(-6, 'day').format('YYYY-MM-DD')
      }

      query.value.endDate = dayjs().format('YYYY-MM-DD')
    }

    const query = ref({
      startDate: dayjs().add(-6, 'day').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
      isPrefixSum: false,
    })

    const fetchData = () => {
      const frDate = dayjs(query.value.startDate)
      const toDate = dayjs(query.value.endDate)

      if (query.value.isPrefixSum && Math.abs(frDate.diff(toDate, 'day')) > 365) {
        pushToast('warning', '조회 기간은 최대 1년을 넘을 수 없습니다.')
        return
      }
      if (query.value.isPrefixSum === false && Math.abs(frDate.diff(toDate, 'day')) > 30) {
        pushToast('warning', '조회 기간은 최대 30일을 넘을 수 없습니다.')
        return
      }

      axios.get('/fa/stats-user-join/comment', {
        params: {
          startDate: query.value.startDate,
          endDate: query.value.endDate,
          isPrefixSum: query.value.isPrefixSum,
        },
      })
        .then(rs => {
          data.value = rs.data
        })
        .catch(() => {
          pushToast('danger', '데이터 조회 중 오류가 발생하였습니다.')
        })
    }

    const excelDownload = async () => {
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet("sheet1")

      worksheet.addRow()

      worksheet.getCell('A1').value = '구분'
      worksheet.mergeCells(`A1:A2`)
      worksheet.getCell('B1').value = '메디컬트렌드'
      worksheet.mergeCells(`B1:C1`)
      worksheet.getCell('D1').value = 'Weekly Choice'
      worksheet.mergeCells(`D1:E1`)
      worksheet.getCell('F1').value = '약품정보'
      worksheet.mergeCells(`F1:G1`)
      worksheet.getCell('H1').value = '공지사항'
      worksheet.mergeCells(`H1:I1`)
      worksheet.getCell('J1').value = '이벤트'
      worksheet.mergeCells(`J1:K1`)

      worksheet.getCell('B2').value = '댓글 수'
      worksheet.getCell('C2').value = '작성자 수'
      worksheet.getCell('D2').value = '댓글 수'
      worksheet.getCell('E2').value = '작성자 수'
      worksheet.getCell('F2').value = '댓글 수'
      worksheet.getCell('G2').value = '작성자 수'
      worksheet.getCell('H2').value = '댓글 수'
      worksheet.getCell('I2').value = '작성자 수'
      worksheet.getCell('J2').value = '댓글 수'
      worksheet.getCell('K2').value = '작성자 수'

      const columns = [
        { key: "date", width: 20 },
        { key: "medicalTrendTotalCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "medicalTrendGroupCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "weeklyChoiceTotalCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "weeklyChoiceGroupCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "drugInfoTotalCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "drugInfoGroupCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "noticeTotalCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "noticeGroupCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "eventTotalCount", width: 15, style: { numFmt: '#,##0' } },
        { key: "eventGroupCount", width: 15, style: { numFmt: '#,##0' } },
      ]

      worksheet.columns = columns

      // eslint-disable-next-line array-callback-return
      data.value.map(e => {
        const record = {
          date: (data.value.length === 1 && e.isPrefixSum) ? '누적 수' : (e.isPrefixSum ? "합계" : e.date),
          medicalTrendTotalCount: e.medicalTrendTotalCount,
          medicalTrendGroupCount: e.medicalTrendGroupCount,
          weeklyChoiceTotalCount: e.weeklyChoiceTotalCount,
          weeklyChoiceGroupCount: e.weeklyChoiceGroupCount,
          drugInfoTotalCount: e.drugInfoTotalCount,
          drugInfoGroupCount: e.drugInfoGroupCount,
          noticeTotalCount: e.noticeTotalCount,
          noticeGroupCount: e.noticeGroupCount,
          eventTotalCount: e.eventTotalCount,
          eventGroupCount: e.eventGroupCount,
        }

        worksheet.addRow(record)
      })

      worksheet.eachRow({ includeEmpty: true }, (row, number) => {
        row.eachCell({ includeEmpty: true }, cell => {
          if (number === 1 || number === 2) {
            // eslint-disable-next-line no-param-reassign
            cell.font = {
              bold: true,
            }

            // eslint-disable-next-line no-param-reassign
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'D3D3D3' },
            }
          }

          // eslint-disable-next-line no-param-reassign
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          }

          if (cell.value === '소계' || cell.value === '합계') {
            // eslint-disable-next-line no-param-reassign
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
            }
          } else {
            // eslint-disable-next-line no-param-reassign
            cell.alignment = {
              vertical: 'middle',
              horizontal: 'left',
            }
          }
        })
      })

      const mimeType = {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], mimeType)

      saveAs(blob, "댓글작성현황.xlsx")
    }

    return {
      data,
      query,
      fetchData,
      changePrefixSum,
      excelDownload,
    }
  },
}
</script>

<style scoped>
.table-bordered th, td {
  border: 1px solid #dee2e6;
}

.table th {
  vertical-align: middle;
}
</style>
